import { useQueryClient } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { updateTrackingInterval } from '@/features/projects/project-details/api/update-tracking-interval';
import { getProjectDetailsQueryKey } from '@/features/projects/shared/hooks/use-project-details';
import { useToast } from '@/shared/hooks/use-toast';

export const useUpdateTrackingInterval = () => {
  const queryClient = useQueryClient();
  const { toast } = useToast();
  const { t } = useTranslation('subproject', { keyPrefix: 'TrackingInterval' });

  return useMutation({
    mutationFn: updateTrackingInterval,
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: getProjectDetailsQueryKey(variables.projectId.toString()),
      });
      toast({ title: t('tracking_interval_saved') });
    },
    onError: () => {
      toast({
        title: t('tracking_interval_error'),
        variant: 'destructive',
      });
    },
  });
};
